/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualWorkingCapitalDto } from '../../models/backend-actual-working-capital-dto';
import { BackendPatchedActualWorkingCapitalRequestDto } from '../../models/backend-patched-actual-working-capital-request-dto';

export interface MonitoringActualsWorkingCapitalPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedActualWorkingCapitalRequestDto;
}

export function monitoringActualsWorkingCapitalPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsWorkingCapitalPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsWorkingCapitalPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualWorkingCapitalDto>;
    }),
  );
}

monitoringActualsWorkingCapitalPartialUpdate$FormData.PATH = '/api/monitoring/actuals/working-capital/{id}/';
